// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"c7428814","453":"e376840d"}[chunkId] + ".chunk.js";
};